// extracted by mini-css-extract-plugin
export default {"topSection":"header_topSection__GKC7b","buttons":"header_buttons__7BssT","link":"header_link__-871A","active":"header_active__k6ds5","logo":"header_logo__L3odY"};